/**
 * @typedef {Object} Feature
 * @property {string} iconKey - key mapped to an icon in Features.jsx
 * @property {"blue" | "coral" | "cobalt" | "teal"} tint - icon chip color
 * @property {string} title - card heading
 * @property {string} body - card body copy
 */

/** @type {Feature[]} */
export const features = [
  {
    iconKey: "groups",
    tint: "blue",
    title: "Find aligned partners",
    body: "Browse thousands of brands in our curated network. Filter by audience, vertical, and reach to find partners who multiply your marketing lift.",
  },
  {
    iconKey: "sparkle",
    tint: "coral",
    title: "Build campaigns fast",
    body: "Launch co-branded giveaways with a drag-and-drop builder. Pre-built templates get you from blank canvas to live campaign in under an hour.",
  },
  {
    iconKey: "trending",
    tint: "cobalt",
    title: "Scale & Convert",
    body: "Every partner shares the giveaway to their list and social media. You reach 5-8x more audience. Track growth and per-partner attribution from your analytics dashboard.",
  },
  {
    iconKey: "insights",
    tint: "teal",
    title: "Measure & optimize",
    body: "Real-time dashboards surface your best partners, channels, and creative. Double down on what compounds and cut what doesn't — every campaign smarter than the last.",
  },
];
